
import './FinancialAnalysisTab.scss';
import { Col, Row , Select , Radio,Spin} from 'antd';
import CustomBarChart from "./CustomBarChart";
import CustomLineChart from './CustomLineChart';
import FinancialAnalysisTree from "./FinancialAnalysisTree";
import FinancialAnalysisSerices from './../../../../services/services/FinancialAnalysisSerices';
import { useEffect,useState } from 'react';
import moment from 'moment';

const labels = ['01-2022', '02-2022', '03-2022', '04-2022', '05-2022', '06-2022', '07-2022'];

export const data = {
	labels,
	datasets: [
		{
			label: 'Quam Lacing adipiscing',
			data: [-355.55,-55.6,-554,-455,-645,-546,-658],
			backgroundColor: '#00bcd4', 
		},
		{
			label: 'Pharetra lacing fringilla',
			data: [315,122,654,46,135,665,663],
			backgroundColor: '#81ffb8',
		},
	],
};

export const data2 = [
    {
        value: -345,
        yearMonth:"01-2022",
        type: 'Quam Lacing adipiscing',
    },
    {
        value: -454,
        yearMonth: '02-2022',
        type: 'Quam Lacing adipiscing',
    },
    {
        value: -543.5,
        yearMonth: '03-2022',
        type: 'Quam Lacing adipiscing',
    },
    {
        value: -835,
        yearMonth: '04-2022',
        type: 'Quam Lacing adipiscing',
    },
    {
        value: -564.9,
        yearMonth: '05-2022',
        type: 'Quam Lacing adipiscing',
    },
    {
        value: -356,
        yearMonth: '06-2022',
        type: 'Quam Lacing adipiscing',
    },
    {
        value: -745,
        yearMonth: '07-2022',
        type: 'Quam Lacing adipiscing',
    },
    {
        value: 334,
        yearMonth:"01-2022",
        type: 'Pharetra lacing fringilla',
    },
    {
        value: 434,
        yearMonth: '02-2022',
        type: 'Pharetra lacing fringilla',
    },
    {
        value: 334.5,
        yearMonth: '03-2022',
        type: 'Pharetra lacing fringilla',
    },
    {
        value: 578,
        yearMonth: '04-2022',
        type: 'Pharetra lacing fringilla',
    },
    {
        value: 454.9,
        yearMonth: '05-2022',
        type: 'Pharetra lacing fringilla',
    },
    {
        value: 634,
        yearMonth: '06-2022',
        type: 'Pharetra lacing fringilla',
    },
    {
        value: 75,
        yearMonth: '07-2022',
        type: 'Pharetra lacing fringilla',
    },
    {
        value: -345,
        yearMonth:"01-2022",
        type: 'CCC',
    },
    {
        value: -454,
        yearMonth: '02-2022',
        type: 'CCC',
    },
    {
        value: -543.5,
        yearMonth: '03-2022',
        type: 'CCC',
    },
    {
        value: -835,
        yearMonth: '04-2022',
        type: 'CCC',
    },
    {
        value: -564.9,
        yearMonth: '05-2022',
        type: 'CCC',
    },
    {
        value: -356,
        yearMonth: '06-2022',
        type: 'CCC',
    },
    {
        value: -745,
        yearMonth: '07-2022',
        type: 'CCC',
    },
];

const options: any = [];
for (let i = 0; i < 100000; i++) {
  const value = `${i.toString(36)}${i}`;
  options.push({
    label: value,
    value,
    disabled: i === 10,
  });
}

const FinancialAnalysisTab = (props: any) => {
    const [lineChartData, setLineChartData] =  useState<[]>([]);
    const [barChartData, setBarChartData] =  useState<[]>([]);
    const [heirarchyData, setHeirarchyData] =  useState<[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [customerId, setCustomerId] = useState<number>(props?.id);
    const [currentYear, setCurrentYear] =  useState<number>(new Date().getFullYear());
    const [lineChartDataLabel, setLineChartDataLabel] =  useState<any>('');
    const [barChartDataLabel, setBarChartDataLabel] =  useState<any>('');
    

    useEffect(() => {
        getLineChartDetails();
        getBarChartDetails();
        getTreeData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    function getLineChartDetails() {
        let object:any = {};
        object.customer_id=customerId;
        object.year=currentYear;
        setLoading(true);
        FinancialAnalysisSerices
        .getLineChartData(object)
        .then((response) => {
            if(response?.data?.code===200){
                setLineChartData(response?.data?.data)
                let label = '';
                label = response?.data?.data?.map((element:any)=>{
                    return element.type;
                });
                setLineChartDataLabel([...new Set(label)].toString())
            }
            setLoading(false);
        })
        .catch((err) => {
           console.log(err)
           setLoading(false);
        });
    }

    function getBarChartDetails() {
        let object:any = {};
        object.customer_id=customerId;
        object.year=currentYear;
        setLoading(true);
        FinancialAnalysisSerices
        .getBarChartData(object)
        .then((response) => {
            if(response?.data?.code===200){
                setBarChartData(response?.data?.data);
                let label = '';
                label = response?.data?.data?.map((element:any)=>{
                    return element.type;
                });
                setBarChartDataLabel([...new Set(label)].toString())
            }
            setLoading(false);
        })
        .catch((err) => {
           console.log(err)
           setLoading(false);
        });
    }

    function getTreeData(){
        let object:any = {};
        object.customer_id=customerId;
        object.year=currentYear;
        setLoading(true);
        FinancialAnalysisSerices
        .getTreeData(object)
        .then((response) => {
            if(response?.data?.code===200){
                setHeirarchyData(response?.data?.data || [])
            }
            setLoading(false);
        })
        .catch((err) => {
           console.log(err)
           setLoading(false);
        });
    }

    return (
        <>
            <Spin spinning={loading} >
                <div className="site-card-wrapper">
                    <Row className="mb-3">
                        <Col span="10" className="cu-d-flex-left">
                            <div className="form-group text-left d-none">
                                <label>Kohde</label><br/>
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="Select&emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={[
                                        {
                                            value: 'As Oy Seinajoen Otso',
                                            label: 'As Oy Seinajoen Otso',
                                        },
                                        {
                                            value: 'As Oy Virontormankatu 10',
                                            label: 'As Oy Virontormankatu 10',
                                        },
                                        {
                                            value: 'As Oy Hiriharju',
                                            label: 'As Oy Hiriharju',
                                        },
                                    ]}
                                />
                            </div>
                        </Col>
                        <Col span="6" className="cu-d-flex-end cu-d-flex-align-item-center">
                            <Radio.Group  onChange={e => setCurrentYear(e.target.value)} className="d-none">
                                <Radio.Button value={currentYear-1} >Prev</Radio.Button>
                                <Radio.Button value={currentYear}>{currentYear}</Radio.Button>
                                <Radio.Button value={currentYear+1}>Next</Radio.Button>
                            </Radio.Group>
                        </Col>
                        <Col span="8" className="d-flex justify-content-end d-none">
                            <div className="card rounded-0 cu-bg-green" >
                                <div className="card-header text-nowrap border-0 py-1">
                                    Paivitetty
                                </div>
                                <div className="card-body py-1">
                                    {moment().format("DD-MM-YYYY")}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='d-flex justify-content-between overflow-auto p-1'>
                        <table className="table table-sm table-bordered">
                            <tbody>
                                <tr className="cu-bg-green text-left">
                                    {/* <th className="fw-600">{lineChartDataLabel}</th> */}
                                    <th className="fw-600">{"Kuluihin (12 kk rullaava ka) suhteutettu maksuvalmius"}</th>
                                </tr>
                                <tr>
                                    <td className="text-left">
                                        <CustomLineChart
                                            data= {lineChartData}
                                        />
                                    </td>
                                </tr>
                                <tr><td className='border-0 bg-white'>&nbsp;</td></tr>
                                <tr className="cu-bg-green text-left">
                                    {/* <th className="fw-600">{barChartDataLabel}</th> */}
                                    <th className="fw-600">{"Tuotot ja kulut"}</th>
                                </tr>
                                <tr>
                                    <td className="text-left">
                                        <CustomBarChart
                                            labels= {labels}
                                            data= {barChartData}
                                            height={120}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <FinancialAnalysisTree 
                            data = {heirarchyData}
                            isExpand={true}
                            {...props}
                        />
                    </div>
                </div>
            </Spin>
        </>
    );
};
export default FinancialAnalysisTab;